import {
  ETable,
  ETableBody,
  ETableCell,
  ETableHead,
  ETableHeader,
  ETableRow,
} from "@/shared/components/tables/e-table";
import { Report } from "@/services/backend/htz/report/types/report";
import t from "@/lang/lang";
import { AirHandlingUnitComponentName } from "@/services/backend/htz/ahu/components/air-handling-unit-data-designation";
import { ResultDot } from "@/services/backend/htz/inspection/components/inspection-result";
import { useErrDocumentNotReady } from "@/shared/bsm/core/document/components/ui/err-document-not-ready";
import { hasFieldError } from "@/shared/lib/errors/validation-error";
import { useHtzReportShowQuery } from "@/services/backend/htz/report/api/report-api";
import { UUID } from "@bitory-gmbh/nidavellir";

export function ItemsTable({ report }: { report: Report }) {
  const { data } = useHtzReportShowQuery({ id: report.id });

  return (
    <ETable>
      <ETableHeader>
        <ETableRow>
          <ETableHead>{t("Komponente")}</ETableHead>
          <ETableHead>{t("Konstruktiv")}</ETableHead>
          <ETableHead>{t("Visuell")}</ETableHead>
          <ETableHead>{t("Mikrobiologisch")}</ETableHead>
          <ETableHead className="w-full">{t("Handlungsempfehlung")}</ETableHead>
          <ETableHead>{t("Ergebnis")}</ETableHead>
        </ETableRow>
      </ETableHeader>
      <ETableBody>
        {data &&
          data.items.map((item) => (
            <ItemRow key={item.id} report={report} itemId={item.id} />
          ))}
      </ETableBody>
    </ETable>
  );
}

function ItemRow({ report, itemId }: { report: Report; itemId: UUID }) {
  const { data } = useHtzReportShowQuery({ id: report.id });
  const { notReadyError } = useErrDocumentNotReady();

  const item = data?.items.find((i) => i.id === itemId);

  if (!data || !item) return;

  return (
    <ETableRow key={item.id}>
      <ETableCell className="align-top font-medium">
        <div className="py-2">
          <AirHandlingUnitComponentName
            id={report.ahuDataId!}
            componentId={item.componentId}
          />
        </div>
      </ETableCell>
      <ETableCell className="align-top">
        <div className="py-2">
          <ResultDot
            result={item.structuralInspectionResult}
            hasError={hasFieldError(
              notReadyError,
              `items.${item.id}.structuralInspectionResult`,
            )}
          />
        </div>
      </ETableCell>
      <ETableCell className="align-top">
        <div className="py-2">
          <ResultDot
            result={item.visualInspectionResult}
            hasError={hasFieldError(
              notReadyError,
              `items.${item.id}.visualInspectionResult`,
            )}
          />
        </div>
      </ETableCell>
      <ETableCell className="align-top">
        <div className="py-2">
          <ResultDot
            result={item.microbialInspectionResult}
            hasError={hasFieldError(
              notReadyError,
              `items.${item.id}.microbialInspectionResult`,
            )}
          />
        </div>
      </ETableCell>
      <ETableCell>
        <div className="py-2">
          {item.recommendations.map((r) => (
            <div key={r}>{r}</div>
          ))}
        </div>
      </ETableCell>
      <ETableCell className="align-top">
        <div className="py-2">
          <ResultDot
            result={item.result}
            hasError={hasFieldError(notReadyError, `items.${item.id}.result`)}
          />
        </div>
      </ETableCell>
    </ETableRow>
  );
}
